module.exports = __webpack_public_path__ + "ejxlicons.f6b8e6ae4a78a44c169a.svg";


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/syncfusion-javascript/Content/ej/web/common-images/spreadsheet/ejxlicons.svg?-dzszjm
// module id = ../../../../syncfusion-javascript/Content/ej/web/common-images/spreadsheet/ejxlicons.svg?-dzszjm
// module chunks = 2